import { render, staticRenderFns } from "./RequestRecord.vue?vue&type=template&id=333518eb&scoped=true"
import script from "./RequestRecord.vue?vue&type=script&lang=js"
export * from "./RequestRecord.vue?vue&type=script&lang=js"
import style0 from "./RequestRecord.vue?vue&type=style&index=0&id=333518eb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333518eb",
  null
  
)

export default component.exports